/**
 * Top Bar
 * - Fetch users geolocation and display relevant text
 * - Store user country code in local storage to prevent repeat API calls
 *
 * @author Matt <matt@joipolloi.com>
 * @package Minifigs 2.0
 */

import { euCountries } from '../../util/euCountryList';

const topBar = () => {
    const topBarAlert = document.getElementById('topBarAlert');
    const topBarAlertTexts = Array.from(document.querySelectorAll('.topBarAlert--text'));
    const topBarAlertDefault = document.querySelector('.topBarAlert--default');
    if (!topBarAlert || !topBarAlertTexts || !topBarAlertDefault) return;

    const displayText = (countryCode) => {
        if (topBarAlertTexts.length > 0) {
            topBarAlertTexts.map((text) => {
                if (text.dataset.countrycode === countryCode) {
                    text.style.display = 'block';
                    topBarAlertDefault.style.display = 'none';
                    topBarAlert.classList.add(`active--${countryCode}`);
                }
            });
        }
    };

    const userCountry = localStorage.getItem('user_country');
    if (userCountry) {
        displayText(userCountry);
    } else {
        fetch('https://api.ipregistry.co/?key=u9b0sa4ypuwudqha')
            .then((response) => response.json())
            .then((data) => data.location.country.code)
            .then((countryCode) => {
                if (euCountries.includes(countryCode)) {
                    displayText('EU');
                    localStorage.setItem('user_country', 'EU');
                } else {
                    displayText(countryCode);
                    localStorage.setItem('user_country', countryCode);
                }
            });
    }
};

export default topBar;
